import linkifyHtml from "linkify-html";

export default function QuillDisplay(props) {
  const html = linkifyHtml(props.content ?? "");

  return (
    <div
      style={{ height: "unset", padding: "0px" }}
      className="ql-editor"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}